<ion-header>
  <ion-toolbar>
    @if (!isLoading) { @if (team) {
    <ion-item lines="none">
      <ion-avatar slot="start">
        <div class="team-avatar">{{ getInitials(team?.name) }}</div>
      </ion-avatar>
      <h4>{{ team?.name }}</h4>
    </ion-item>
    } @else {
    <ion-title>{{ 'Select participant' | translate }}</ion-title>
    }

    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    } @else {
    <div class="ion-padding content-width">
      <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    </div>
    }
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (!isLoading) { @if (players?.length) {
  <app-list-search
    [userList]="players"
    (searchResult)="players = $event"
  ></app-list-search>

  <ion-list>
    @for (p of players; let i=$index; track i) {
    <ion-item-sliding>
      <ion-item>
        <ion-checkbox
          labelPlacement="end"
          justify="start"
          color="secondary"
          (ionChange)="selectPlayer($event, i)"
        >
          <div class="player-item">
            @if(p?.profile_image){
            <img class="player-photo" [src]="p?.profile_image" alt="" />
            } @else {
            <ion-icon name="person-circle-outline" size="large"></ion-icon>
            }
            {{ p.first_name }}
            {{ p.last_name }}
          </div>
        </ion-checkbox>
      </ion-item>
      <ion-item-options side="end" *ngIf="isOwner">
        <ion-item-option
          (click)="removePlayer(p.person._id)"
          color="danger"
          translate
          >Remove</ion-item-option
        >
      </ion-item-options>
    </ion-item-sliding>
    }
  </ion-list>
  } @else {
  <app-empty-page
    text="{{'Click on the plus button below to add a player' | translate}}"
    iconName="people"
  ></app-empty-page>
  } @if(!team?.organisations?.length) {
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="addPlayer()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  } } @else {
  <div class="ion-padding content-width" *ngFor="let item of [0, 1, 2]">
    <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  </div>
  }
</ion-content>
